import React, { useContext, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import GlobalContext from '../../../store/global-context'
import './OrderItem.css'
import OrderStatusPill from '../../shared/OrderStatusPill/OrderStatusPill'
import ItemCountPill from '../../shared/ItemCountPill/ItemCountPill'

function OrderItem(props) {
    let navigate = useNavigate();

    const globalCtx = useContext(GlobalContext);

    useEffect(() => {
        globalCtx.setOrderStatus(props.order.status);
    }, []);

    let order = props.order;
    let index = props.index;

    function orderClickedHandler(order) {
        navigate(`/SupplyList/${order.id}/${order.name}/${order.status}`);
    }

    return (
        <>
            {(props.layout === 1 || props.layout === 2) &&
                <div className={"card h-100 order-item card-radio"} key={index} >
                    <div className='card-container'>
                        <div className='details-block' onClick={() => orderClickedHandler(order)}>
                            <div className="title-block">
                                <div className="pills-block">
                                    <OrderStatusPill status={order.status} />
                                </div>
                            </div>
                            <div className="date-block">
                                <span>OrderDate: {order.orderDate}</span><br />
                                <span>Ship Date: {order.shipDate}</span>
                            </div>
                            <div className="creator-block">
                                <div className="pills-block">
                                    <span className="badge rounded-pill data-badge-red day-badge">
                                        <i className="bi bi-person ms-1"></i> {order.createdBy}
                                    </span>
                                </div>
                                <div className="pills-block">
                                    <ItemCountPill itemCount={order.itemCount} />
                                </div>
                            </div>
                        </div>
                        <div className="button-block order-info-section">
                            <div className="btn-group">
                                <button className="btn btn-secondary dropdown-toggle"
                                    type="button" id={order.id} data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                </button>
                                <ul className="dropdown-menu" aria-labelledby={order.id}>
                                    <li>
                                        <a className="dropdown-item order-item-action" href="#" onClick={props.onEditOrder}>
                                            <i className="bi bi-pencil"></i> {order.status === 'Incomplete' ? 'Edit' : 'Details'}
                                        </a>
                                    </li>
                                    <li>
                                        <Link className='dropdown-item order-item-action' to={`/SupplyList/${order.id}/${order.name}/${order.status}`}>
                                            <i className="bi bi-list-ol"></i> Supplies
                                        </Link>
                                    </li>
                                    {order.status === 'Incomplete' && !props.hasCurrentSeasonSubmittedOrder &&
                                        <li>
                                            <a className="dropdown-item order-item-action" href="#" onClick={props.onSubmitOrder}>
                                                <i className="bi bi-save"></i> Submit
                                            </a>
                                        </li>
                                    }
                                    {order.status === 'Incomplete' &&
                                        <li>
                                            <a className="dropdown-item order-item-action" href="#" onClick={props.onCancelOrder}>
                                                <i className="bi bi-x-circle"></i> Cancel
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.layout === 3 &&
                <div key={index} className={"card h-100 order-item card-radio"}>
                    <div className='card-container'>
                        <div className='details-block' onClick={() => orderClickedHandler(order)}>
                            <div className="title-block">
                                <span className='order-title'>
                                    {order.status === 'Incomplete' ? '' : 'Order Number: '}
                                </span>
                                <div className="pills-block" style={{ position: 'static' }} >
                                    <OrderStatusPill status={order.status} />
                                </div>
                            </div>
                            <div className="date-block">
                                <span>OrderDate: {order.orderDate}</span><br />
                                <span>Ship Date: {order.shipDate}</span>

                            </div>
                            <div className="creator-block">
                                <div className="pills-block" style={{ position: 'static' }}>
                                    <span className="badge rounded-pill data-badge-red day-badge">
                                        <i className="bi bi-person ms-1"></i> {order.createdBy}
                                    </span>
                                </div>
                                <div className="pills-block">
                                    <ItemCountPill itemCount={order.itemCount} />
                                </div>
                            </div>
                        </div>
                        <div className="button-block order-info-section">
                            <div className="btn-group">
                                <button className="btn btn-secondary dropdown-toggle"
                                    type="button" id={order.id} data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                </button>
                                <ul className="dropdown-menu" aria-labelledby={order.id}>
                                    <li>
                                        <a className="dropdown-item order-item-action" href="#" onClick={props.onEditOrder}>
                                            <i className="bi bi-pencil"></i> {order.status === 'Incomplete' ? 'Edit' : 'Details'}
                                        </a>
                                    </li>
                                    <li>
                                        <Link className='dropdown-item order-item-action' to={`/SupplyList/${order.id}/${order.name}/${order.status}`}>
                                            <i className="bi bi-list-ol"></i> Supplies
                                        </Link>
                                    </li>
                                    {order.status === 'Incomplete' &&
                                        <li>
                                            <a className="dropdown-item order-item-action" href="#" onClick={props.onSubmitOrder}>
                                                <i className="bi bi-save"></i> Submit
                                            </a>
                                        </li>
                                    }
                                    {order.status === 'Incomplete' &&
                                        <li>
                                            <a className="dropdown-item order-item-action" href="#" onClick={props.onCancelOrder}>
                                                <i className="bi bi-x-circle"></i> Cancel
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.layout === 4 &&
                <>
                    <td onClick={() => orderClickedHandler(order)} >
                        <div className="d-flex justify-content-between align-items-center">
                            <OrderStatusPill status={order.status} short={false} />
                        </div>
                    </td>
                    <td onClick={() => orderClickedHandler(order)}>{order.orderDate}</td>
                    <td onClick={() => orderClickedHandler(order)}>{order.shipDate}</td>
                    <td onClick={() => orderClickedHandler(order)}>{order.createdBy}</td>
                    <td onClick={() => orderClickedHandler(order)}>{order.itemCount}</td>
                    <td>
                        <div className="d-flex justify-content-center position-relative">
                            <div className="btn-group">
                                <button className="btn btn-secondary dropdown-toggle"
                                    type="button" id={`dropdown-${order.id}`}
                                    data-bs-toggle="dropdown" data-bs-auto-close="true"
                                    aria-expanded="false">
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end"
                                    aria-labelledby={`dropdown-${order.id}`}
                                    style={{ zIndex: 9999, position: 'absolute' }}>
                                    <li>
                                        <a className="dropdown-item order-item-action" href="#" onClick={props.onEditOrder}>
                                            <i className="bi bi-pencil"></i> {order.status === "Incomplete" ? 'Edit' : 'Details'}
                                        </a>
                                    </li>
                                    <li>
                                        <Link className='dropdown-item order-item-action' to={`/SupplyList/${order.id}/${order.name}/${order.status}`}>
                                            <i className="bi bi-list-ol"></i> Supplies
                                        </Link>
                                    </li>
                                    {order.status === 'Incomplete' &&
                                        <>
                                            <li>
                                                <a className="dropdown-item order-item-action" href="#" onClick={props.onSubmitOrder}>
                                                    <i className="bi bi-save"></i> Submit
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item order-item-action" href="#" onClick={props.onCancelOrder}>
                                                    <i className="bi bi-x-circle"></i> Cancel
                                                </a>
                                            </li>
                                        </>
                                    }
                                </ul>
                            </div>
                        </div>
                    </td>
                </>
            }
        </>
    )
}

export default OrderItem
